import React, { useState } from 'react';
import { axiosInstance } from 'config/api';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    VStack,
    Input,
    Select,
    useToast,
    FormControl,
    FormLabel,
} from 'components-lib';
import getCurrentDate from 'views/admin/helpers/formatDate';
import FileUploadField from '../../../../../components/FileUploadField';
/**
 * ShowModal - Lab Report Upload Interface
 *
 * Modal component for uploading lab reports and medical documents.
 * Features file validation, progress tracking, and integration with
 * the lab reports management system.
 *
 * @component
 * @since 1.0.0
 * @author Kifayti Health
 */
const MyModal = ({ closeModal, user_id, onSuccess }) => {
    const [reportType, setReportType] = useState('Select report type');
    const [file, setFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [otherText, setOtherText] = useState('');
    const [selectedDate, setSelectedDate] = useState(getCurrentDate());
    const toast = useToast();
    const [labReportUrl,SetlabReportUrl] = useState("");



    const uploadFile = async (file) => {
        const formData = new FormData();
        // const fileName = `uploaded-file-${Date.now()}.${file.name.split('.').pop()}`;
        formData.append("file", file);

        try {
            const uploadResponse = await axiosInstance.post(
                "/api/upload",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        // "Authorization": `Bearer ${token}`, // Ensure `token` is available in the scope
                    },
                    maxBodyLength: Infinity,
                }
            );
            return uploadResponse?.data?.objectUrl;
        } catch (error) {
            console.error("File upload failed:", error);
            throw new Error("Failed to upload file.");
        }
    };

    const uploadLabReport = async ({ patientId, labReportUrl, }) => {

        const URL = await uploadFile(file)


        const payload = {
            Report_Type: reportType,
            Date: selectedDate || new Date().toISOString().split('T')[0],
            patient_id: patientId,
            Lab_Report: URL,
        };

        const response = await axiosInstance.post('/api/lab/add', payload);
        return response.data;
    };


    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file || !reportType) {
            toast({
                title: "Error",
                description: "Please select a file and report type",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        setIsUploading(true);
        try {


            await uploadLabReport({
                patientId: user_id,
                labReportUrl,
            });

            toast({
                title: "Success",
                description: "Lab report uploaded successfully",
                status: "success",
                duration: 3000,
                isClosable: true,
            });

            if (onSuccess) {
                onSuccess();
            }
            closeModal();
        } catch (error) {
            toast({
                title: "Error",
                description: "Failed to upload lab report",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setIsUploading(false);
        }
    };

    const [onOther, setOnOther] = useState(false);


    return (
        <Modal isOpen={true} onClose={closeModal} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Upload Lab Report</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4} justify="center" align="stretch">
                        <FormControl>
                            <div className="mb-4">
                                <label className="block text-gray-700 text-sm font-semibold mb-2">
                                    Lab Report Date:
                                </label>
                                <input
                                    type="date"
                                    id="Date"
                                    className="w-full border-2 py-2 px-3 rounded focus:outline-none focus:border-amber-950"
                                    value={selectedDate}
                                    max={getCurrentDate()}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                />
                            </div>
                            <FormLabel>Report Type</FormLabel>
                            <Select
                                placeholder={reportType}
                                value={reportType}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setReportType(val);
                                    if (val === "Other") {
                                        setOnOther(true);
                                        setReportType("");
                                    } else {
                                        setOnOther(false);
                                        // setOtherText("");
                                    }
                                }}
                            >
                                <option value="Blood Test">Blood Test</option>
                                <option value="Urine Test">Urine Test</option>
                                <option value="X-Ray">X-Ray</option>
                                <option value="MRI">MRI</option>
                                <option value="CT Scan">CT Scan</option>
                                <option value="Other">Other</option>
                            </Select>
                        </FormControl>

                        {onOther && (
                            <FormControl>
                                <FormLabel>Specify report type</FormLabel>
                                <VStack spacing={2} align="stretch">
                                    <Input
                                        value={reportType}
                                        placeholder='Specify other report type'
                                        onChange={(e) => {
                                            setReportType(e.target.value);
                                        }}
                                    />
                                </VStack>
                            </FormControl>
                        )}

                        <FormControl>


                            <FileUploadField
                                label="Select File"
                                id="lab-report-file"
                                name="lab_report"
                                selectedFile={file}
                                onChange={handleFileChange}
                                accept=".pdf,.jpg,.jpeg,.png"
                                helperText="Max 10MB"
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={closeModal}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme="blue"
                        onClick={handleUpload}
                        isLoading={isUploading}
                        loadingText="Uploading..."
                    >
                        Upload
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default MyModal;
